import { moneyFormat } from 'utils'
import { INTEREST_FREE_ADVANCE_MAX_AMOUNT } from './credit'

// Assets
import Rocket from '../assets/images/emojis/rocket.png'
import MoneyBag from '../assets/images/emojis/money-bag.png'
import Crown from '../assets/images/emojis/crown.png'
import GreenHeart from '../assets/images/emojis/green-heart.png'
import Thunderbolt from '../assets/images/emojis/thunderbolt.png'
import Card from '../assets/images/card.png'
import LineChart from '../assets/images/emojis/line-chart.png'
import Dialog from '../assets/images/emojis/dialog.png'

export const MEMBERSHIP_BENEFITS_LIST = [
  {
    title: 'Adelantos en tu tarjeta Wayni',
    description: `Tasa 0 para montos de hasta ${moneyFormat(
      INTEREST_FREE_ADVANCE_MAX_AMOUNT
    )}`,
    img: Thunderbolt,
    alt: '⚡'
  },
  {
    title: 'Tasas de interés preferenciales',
    img: Crown,
    alt: '👑',
    description: 'Accedé a las mejores tasas de Wayni.'
  },
  {
    title: 'Tarjeta física bonificada',
    description: 'Con la función pausar para tu mayor seguridad.',
    img: Card,
    alt: '💳'
  },
  {
    title: '¡Desembolsos Turbo!',
    description: 'Obtené tus préstamos más rápido.',
    clarification: '(En 5 horas hábiles de lunes a viernes)',
    img: Rocket,
    alt: '🚀'
  },
  {
    title: 'Mayores montos',
    img: MoneyBag,
    description: 'Llevate montos más grandes en tus préstamos.',
    alt: '💰'
  },

  {
    title: 'Wayni Beneficios',
    alt: '💚',
    img: GreenHeart,
    description: 'Descuentos exclusivos de hasta el 50% en tus compras.'
  },
  {
    title: 'Tu perfil de crédito',
    alt: '📈',
    img: LineChart,
    description:
      'Conocé tu informe crediticio y maximizá tu potencial financiero.'
  },
  {
    title: 'Atención personalizada por WhatsApp',
    alt: '💬',
    img: Dialog,
    description: 'Respondemos tus consultas al instante.',
    clarification: '(En días y horarios hábiles)'
  }
]

// subscriptions suborigins
export enum SUBORIGIN_OPTIONS {
  FIRST_LOAN = 'FIRST_LOAN',
  RENEWAL = 'RENEWAL',
  CASH_ADVANCE = 'CASH_ADVANCE',
  INTEREST_FREE_ADVANCE = 'INTEREST_FREE_ADVANCE',
  HUB = 'HUB',
  CARD = 'CARD',
  CREDIT_PROFILE = 'CREDIT_PROFILE',
  NOT_DEFINED = 'NOT_DEFINED'
}

export enum SUBORIGIN_USER_PATHS {
  'tarjeta-fisica' = 'CARD',
  'perfil-crediticio' = 'CREDIT_PROFILE',
  HUB = 'HUB'
}
